/*
  brand-pdp.js — ürün sayfası davranışları (U06). brand-pdp-main bölümü `defer` ile yükler; sayfada bir kez çalışır.
  Sözleşme: core/CONVENTIONS.md §3. Global yok (yalnız tek-çalışma bayrağı), Horizon olay adı taklit edilmez.

  1) Seçenek çipleri (brand-pdp-option): tıklama Horizon'un kendi variant-picker denetimini seçer ve `change` tetikler
     (radio: checked + change; açılır liste: select.value + change). Varyant id'yi BİZ yazmayız: Horizon varyantı getirir,
     ana formu (`form[data-type="add-to-cart-form"]`) ve fiyatı kendisi günceller. Denetim bulunamazsa çip varyant URL'sine
     gider (JS'siz yol ile aynı sonuç). Yerel seçici yalnız çip hazır olunca (`data-ready`) CSS ile gizlenir (T-19 ilkesi).
  2) `variant:update` (Horizon, events.js): aynı bölümdeki `[data-brand-refresh][id]` öğeleri sunucunun yeni HTML'inden yenilenir
     (Horizon product-price ile aynı yöntem).
  3) `brand-copy-code`: numune kodu kopyala düğmesi (ana sayfa numune bölümüyle aynı öğe; tanımlıysa yeniden tanımlanmaz).
  4) Tasarım bekçisi: `[data-brand-design="required"]` (gang sheet builder ürünü) içindeki `/cart/add` formu gönderilirse
     engellenir, odak GSW düğmesine taşınır. Builder ürününde sayfadan meşru sepete ekleme yolu yoktur (GSW kendi sayfasından
     tasarımlı ekler). Bekçi yalnız bu bölümün formuna bakar; başka sayfa/bölüm etkilenmez. Sepet tarafı bekçisi U07'de.
  Tek çalışma işareti global değişken değil, <html data-brand-pdp-js> özniteliğidir.
*/
(function () {
  'use strict';
  var docEl = document.documentElement;
  if (docEl.hasAttribute('data-brand-pdp-js')) return;
  docEl.setAttribute('data-brand-pdp-js', '');

  var OPTION = '[data-brand-component="pdp-option"]';

  function sectionOf(el) {
    return (el && el.closest && el.closest('.shopify-section')) || document;
  }

  function nativeControl(scope, inputId) {
    var pickers = scope.querySelectorAll('variant-picker');
    for (var i = 0; i < pickers.length; i++) {
      if (pickers[i].closest('product-card, quick-add-component, dialog')) continue;
      var el = pickers[i].querySelector('[data-input-id="' + inputId + '"]');
      if (el) return el;
    }
    return null;
  }

  function markReady(root) {
    var scope = sectionOf(root);
    var first = root.querySelector('[data-input-id]');
    if (first && nativeControl(scope, first.getAttribute('data-input-id'))) {
      root.setAttribute('data-ready', '');
    }
  }

  function initOptions(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(OPTION), markReady);
  }

  function choose(btn) {
    var root = btn.closest(OPTION);
    if (!root) return;
    var ctl = nativeControl(sectionOf(root), btn.getAttribute('data-input-id'));
    if (!ctl) {
      var url = btn.getAttribute('data-url');
      if (url) window.location.href = url;
      return;
    }
    if (ctl.tagName === 'OPTION') {
      var sel = ctl.closest('select');
      if (!sel || sel.value === ctl.value) return;
      sel.value = ctl.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (ctl.tagName === 'INPUT') {
      if (ctl.checked) return;
      ctl.checked = true;
      ctl.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      return;
    }
    var list = btn.closest('[data-brand-option-list]');
    if (list) {
      Array.prototype.forEach.call(list.querySelectorAll('[data-input-id]'), function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
    }
    root.setAttribute('aria-busy', 'true');
    window.setTimeout(function () { root.removeAttribute('aria-busy'); }, 4000);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(OPTION + ' [data-input-id]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-pressed') === 'true') return;
    choose(btn);
  });

  document.addEventListener('variant:update', function (e) {
    var html = e.detail && e.detail.data && e.detail.data.html;
    if (!html || typeof html.getElementById !== 'function') return;
    var scope = sectionOf(e.target);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-brand-refresh][id]'), function (el) {
      var fresh = html.getElementById(el.id);
      if (!fresh) return;
      el.innerHTML = fresh.innerHTML;
      if (fresh.hasAttribute('hidden')) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
      el.removeAttribute('aria-busy');
    });
    initOptions(scope);
  });

  /* 3) numune kodu kopyala */
  if (window.customElements && !window.customElements.get('brand-copy-code')) {
    window.customElements.define(
      'brand-copy-code',
      class extends HTMLElement {
        connectedCallback() {
          var btn = this.querySelector('button');
          var status = this.querySelector('[role="status"]');
          var code = this.getAttribute('data-code') || '';
          if (!btn || !code || !navigator.clipboard || !navigator.clipboard.writeText) return;
          btn.hidden = false;
          var label = btn.textContent;
          var timer = null;
          btn.addEventListener('click', function () {
            navigator.clipboard.writeText(code).then(
              function () {
                var done = btn.getAttribute('data-copied') || '';
                btn.textContent = done || label;
                if (status) {
                  status.textContent = '';
                  window.setTimeout(function () { status.textContent = done; }, 50);
                }
                window.clearTimeout(timer);
                timer = window.setTimeout(function () {
                  btn.textContent = label;
                  if (status) status.textContent = '';
                }, 2500);
              },
              function () {}
            );
          });
        }
      }
    );
  }

  /* 4) tasarım bekçisi (builder PDP) */
  window.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (!f || !f.closest) return;
      var root = f.closest('[data-brand-design="required"]');
      if (!root) return;
      if (!/\/cart\/add/.test(f.getAttribute('action') || '')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var cta = root.querySelector('.gsw-launcher a, .gsw-button');
      var live = root.querySelector('[data-brand-pdp-live]');
      if (cta) {
        try { cta.scrollIntoView({ block: 'center' }); } catch (err) {}
        cta.focus();
        if (live) {
          live.textContent = '';
          window.setTimeout(function () { live.textContent = (cta.textContent || '').replace(/\s+/g, ' ').trim(); }, 50);
        }
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initOptions(document); });
  } else {
    initOptions(document);
  }
})();
